import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import PaginaServicos from "./components/PaginaServicos";
import PaginaAgendamento from "./components/PaginaAgendamento";
import PaginaAdmin from "./components/PaginaAdmin";

export default function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<PaginaServicos />} />
        <Route path="/agendamento/:serviceId" element={<PaginaAgendamento />} />
        <Route path="/rocar/admin" element={<PaginaAdmin />} />
      </Routes>
    </Router>
  );
}
